module.exports = __webpack_public_path__ + "img/1863970.d6a682d5.svg";